var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-0", attrs: { fluid: "" } },
    [
      _c("Header", {
        attrs: { areaLoading: _vm.areaLoading },
        on: {
          statusChange: _vm.statusChangeFunc,
          clickGroupEdit: _vm.clickGroupEditFunc,
        },
      }),
      _c(
        "v-col",
        {
          staticClass: "pa-0",
          attrs: { id: "main_content_maxwidthset", cols: "12" },
        },
        [
          _vm.search
            ? _c(
                "v-row",
                { staticClass: "ma-0 pa-0" },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-0 mt-2 pb-1",
                      attrs: { cols: "12", id: "search_result" },
                    },
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "ma-0 pa-0 pr-8",
                          attrs: { justify: "space-between", align: "center" },
                        },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0",
                              attrs: { cols: "auto" },
                            },
                            [_vm._v(_vm._s(_vm.tc("filteringResult")))]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0",
                              attrs: { cols: "auto" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "back_clean_btn ma-0 pa-2 ml-3",
                                  attrs: {
                                    id: "back_clean_btn1",
                                    width: "auto",
                                    height: "auto",
                                    elevation: "0",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.deleteSearchResult()
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "ma-0 pa-0",
                                      staticStyle: { color: "white" },
                                      attrs: { align: "center" },
                                    },
                                    [
                                      _c("v-img", {
                                        staticClass: "ma-0 pa-0 mr-2",
                                        attrs: {
                                          "max-height": "1.5rem",
                                          "max-width": "1.5rem",
                                          src: require("@/assets/images/close_grey.png"),
                                        },
                                      }),
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.tc("cancelSearch")) +
                                          " "
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-row",
            { staticClass: "ma-0 pa-0", attrs: { justify: "center" } },
            [
              _c(
                "v-col",
                { staticClass: "ma-0 pa-0 mt-10 mb-10", attrs: { cols: "10" } },
                [
                  _c(
                    "v-row",
                    {
                      staticClass: "ma-0 pa-0",
                      staticStyle: { "margin-left": "3rem !important" },
                    },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0 title_grey",
                          attrs: { cols: "3" },
                        },
                        [_vm._v(" " + _vm._s(_vm.tc("cameraName")) + " ")]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0 title_grey",
                          attrs: { cols: "2" },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.tc("operationStartDate")) + " "
                          ),
                        ]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0 title_grey",
                          attrs: { cols: "3" },
                        },
                        [_vm._v(" " + _vm._s(_vm.tc("uauSerial")) + " ")]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0 title_grey",
                          attrs: { cols: "2" },
                        },
                        [_vm._v(" " + _vm._s(_vm.tc("portName")) + " ")]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0 title_grey",
                          attrs: { cols: "2" },
                        },
                        [_vm._v(" " + _vm._s(_vm.tc("cameraStatus")) + " ")]
                      ),
                    ],
                    1
                  ),
                  _vm.areaLoading == false
                    ? [
                        _vm.storeArray.length > 0
                          ? [
                              _c(
                                "v-list",
                                {
                                  staticClass: "test_list",
                                  attrs: { id: "status_list" },
                                },
                                _vm._l(_vm.storeArray, function (item, index) {
                                  return _c(
                                    "v-list-group",
                                    {
                                      key: index,
                                      staticClass: "detail_group",
                                      attrs: {
                                        "sub-group": "",
                                        color: "black",
                                        ripple: false,
                                        value: _vm.selectedStatus,
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "v-list-item-content",
                                                  [
                                                    _c(
                                                      "v-row",
                                                      {
                                                        staticClass:
                                                          "ma-0 pa-0",
                                                      },
                                                      [
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "ma-0 pa-0",
                                                            attrs: {
                                                              cols: "12",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  item.customerName
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    _vm._l(
                                      item.cameras,
                                      function (detail, index_detail) {
                                        return _c(
                                          "v-list-item",
                                          {
                                            key: index_detail,
                                            staticClass: "ma-0 pa-0",
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleCameraClick(
                                                  detail
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "v-list-item-content",
                                              { staticClass: "detail_list" },
                                              [
                                                _c(
                                                  "v-row",
                                                  {
                                                    staticClass: "ma-0 pa-0",
                                                    attrs: { align: "center" },
                                                  },
                                                  [
                                                    _c(
                                                      "v-col",
                                                      {
                                                        staticClass:
                                                          "ma-0 pa-0 pr-4",
                                                        attrs: { cols: "3" },
                                                      },
                                                      [
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass: "ma-0",
                                                            staticStyle: {
                                                              "white-space":
                                                                "pre-wrap",
                                                              "word-break":
                                                                "break-all",
                                                              "word-wrap":
                                                                "break-word",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "cameraNameLength"
                                                                  )(
                                                                    detail.cameraName
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      {
                                                        staticClass:
                                                          "ma-0 pa-0",
                                                        attrs: { cols: "2" },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "dateFormat"
                                                              )(
                                                                detail.createTime
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      {
                                                        staticClass:
                                                          "ma-0 pa-0",
                                                        attrs: { cols: "3" },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              detail.serialCd
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      {
                                                        staticClass:
                                                          "ma-0 pa-0",
                                                        attrs: { cols: "2" },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              detail.portName
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                    detail.isOnline
                                                      ? _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "ma-0 pa-0",
                                                            attrs: {
                                                              cols: "2",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-col",
                                                              {
                                                                staticClass:
                                                                  "ma-0 pa-0",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.t(
                                                                        "online"
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      : _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "ma-0 pa-0",
                                                            attrs: {
                                                              cols: "2",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-row",
                                                              {
                                                                staticClass:
                                                                  "ma-0 pa-0",
                                                              },
                                                              [
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    staticClass:
                                                                      "ma-0 pa-0 status_off",
                                                                    staticStyle:
                                                                      {
                                                                        "align-self":
                                                                          "center",
                                                                      },
                                                                    attrs: {
                                                                      cols: "auto",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          _vm.t(
                                                                            "offline"
                                                                          )
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    1
                                  )
                                }),
                                1
                              ),
                            ]
                          : [
                              _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-15",
                                  attrs: { cols: "12" },
                                },
                                [_vm._v(" " + _vm._s(_vm.t("noData")) + " ")]
                              ),
                            ],
                      ]
                    : [
                        _c(
                          "v-col",
                          {
                            staticClass: "ma-0 pa-2",
                            attrs: { cols: "12", align: "left" },
                          },
                          [
                            _c("v-skeleton-loader", {
                              attrs: {
                                boilerplate: false,
                                elevation: "0",
                                dark: "",
                                type: "list-item-two-line, list-item-two-line, list-item-two-line, list-item-two-line",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                ],
                2
              ),
            ],
            1
          ),
          _c("GroupEditDialog", {
            attrs: {
              dialogVisible: _vm.groupEditDialogVisible,
              fromHeader: false,
              fromNoti: false,
              cameraStatusStoreList: _vm.currentSelectedData,
            },
            on: {
              visible: _vm.groupEditDialogVisibleFunc,
              selectedStores: _vm.selectedStoresFunc,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }